import { initialCompaniesState } from 'redux/initialState';
import { status } from 'constants/general';

import companiesActionTypes from './action-types';

const companiesReducer = (state = initialCompaniesState, { type }) => {
  switch (type) {
    case companiesActionTypes.FETCH_ADD_OR_EDIT_COMPANY_SUBMISSION:
      return {
        ...state,
        addOrEditCompany: {
          status: status.FETCHING,
        },
      };

    case companiesActionTypes.FETCH_ADD_OR_EDIT_COMPANY_SUBMISSION_SUCCESS:
      return {
        ...state,
        addOrEditCompany: {
          status: status.SUCCESS,
        },
      };

    case companiesActionTypes.FETCH_ADD_OR_EDIT_COMPANY_SUBMISSION_FAIL:
      return {
        ...state,
        addOrEditCompany: {
          status: status.FAIL,
        },
      };

    default:
      return state;
  }
};

export default companiesReducer;
